import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { CouponCodeService } from '../../../services/couponCode.service';

@Component({
    selector: 'add-edit-couponCode-window',
    templateUrl: './addEditCouponCode.component.html'
})
export class AddEditCouponCodeComponent implements OnInit {
    public title: string;
    public mode: string;
    public list: any[] = [];
    public couponCodedata: any = {};

    isLoading: boolean = false;
    @Output() couponCodeLoadEvent = new EventEmitter();

    constructor(private couponCodeService: CouponCodeService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService) { }

    ngOnInit(): void {
        setTimeout(() => {
            $('#campaign_name').focus();
        }, 100);

        if (this.couponCodedata.mode === 'Add') {
            this.couponCodedata.status = 'Active';
            this.couponCodedata.discount_type = 'Amount'; // Default to Amount
            this.couponCodedata.discount_amount = 0;
            this.couponCodedata.discount_percentage = 0;
        }
    }

    onDiscountTypeChange(discountType: string): void {
        if (discountType === 'Amount') {
            this.couponCodedata.discount_percentage = 0;
        } else if (discountType === 'Percentage') {
            this.couponCodedata.discount_amount = 0;
        }
    }

    onSaveCouponCode(): void {
        let that = this;
        this.isLoading = true;

        this.couponCodeService
            .addUpdateCouponCode(this.couponCodedata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.couponCodeLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/couponCode/addEditCouponCode.component.ts